import * as Sentry from '@sentry/browser';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ENV, startAmplitudeTracking, TIMESTAMP} from './Common';
import {Router} from './Router';
import 'react-datepicker/dist/react-datepicker.css';

if (__SENTRY_DSN__)
  Sentry.init({
    dsn: __SENTRY_DSN__,
    environment: ENV(),
    release: TIMESTAMP(),
    tracesSampleRate: 0.25,
  });

startAmplitudeTracking();

const mountNode = document.getElementById('mount');
if (!mountNode) throw new Error('Mount node not found!');
const root = createRoot(mountNode);
root.render(
  <BrowserRouter>
    <Router />
  </BrowserRouter>,
);
